import React from 'react';
import { Section } from '../ui/Section';
export function ImpactCounters() {
  return <Section background="deep-blue" data-id="element-98">
      <div className="text-center mb-12" data-id="element-99">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-4" data-id="element-100">
          Our Impact
        </h2>
        <p className="text-lg font-inter max-w-3xl mx-auto opacity-90" data-id="element-101">
          Every donation helps us make a meaningful difference in the lives of
          underserved communities in Egypt.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-102">
        {[{
        value: 'Pending',
        label: 'Pallets Shipped'
      }, {
        value: 'Pending',
        label: 'Medical Items'
      }, {
        value: 'Pending',
        label: 'Clinics Served'
      }, {
        value: 'Pending',
        label: 'Egyptian Regions'
      }].map((counter, index) => <div key={index} className="text-center" data-id="element-103">
            <div className="font-playfair font-bold text-4xl md:text-5xl text-primary-gold mb-2" data-id="element-104">
              {counter.value}
            </div>
            <div className="font-inter text-lg" data-id="element-105">{counter.label}</div>
          </div>)}
      </div>
      <div className="mt-8 text-center" data-id="element-106">
        <p className="font-inter opacity-80 max-w-2xl mx-auto" data-id="element-107">
          Supplies are currently being donated and processed. We are working
          diligently to collect, sort, and ship medical supplies to communities
          in need. Check back soon for updated impact metrics.
        </p>
      </div>
    </Section>;
}